// Modules
import React from 'react';
import _ from 'lodash';

import { SVGButton } from 'components/widgets/buttons/buttons';
import { alerts } from 'modules/alerts/actions';
import Company from 'services/data/company';
import CompanyForm from 'components/models/company/company-form';
import CompanyLink from 'components/models/company/company-link';
import FormPopover from 'components/widgets/overlays/form';
import SVG from 'components/widgets/icons/svg';


// Component
export default class CompanyAddPopup extends React.Component {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const create = _.clone(values);
    create.nickname = create.name;

    return Company.create(create)
      .then(company =>
        alerts.success({
          title: `${company.name} added!`,
          subtitle: <CompanyLink company={company}>View company</CompanyLink>
        })
      )
      .then(this.addForm.toggle)
      .catch(alerts.catchError);
  }

  render() {
    return (
      <div className="add-company">
        <FormPopover
          target={<SVGButton src="svg/add.svg" className="add-item-link" />}
          title="Add Company"
          popoverClassName="company-form"
          ref={(el) => { this.addForm = el; }}
        >
          <div>
            <div className="form-header">
              <SVG src="svg/company.svg" className="company" />
              <h5 className="form-title">Add Company</h5>
              <SVG onClick={() => this.addForm.toggle()} className="close" src="svg/close.svg" />
            </div>
            <CompanyForm
              onSubmit={this.onSubmit}
              form="companyForm-new"
              quickAdd
            />
          </div>
        </FormPopover>
      </div>
    );
  }
}
